import {
	type FC,
	type ReactNode,
	type RefObject,
	createContext,
	createRef,
	useCallback,
	useContext,
	useMemo,
	useState,
} from "react";

import { notImplementedFn } from "~/utils/context";

type Portal = RefObject<HTMLDivElement | null>;
export interface TopBarContextStateType {
	portal?: Portal;
	setTopBarPortal: (portal: Portal) => void;
	sharePopoverOpen: boolean;
	setSharePopoverOpen: (open: boolean) => void;
}

const TopBarContext = createContext<TopBarContextStateType>({
	portal: createRef(),
	setTopBarPortal: notImplementedFn("setPortal", "TopBarContext", undefined),
	sharePopoverOpen: false,
	setSharePopoverOpen: notImplementedFn("setSharePopoverOpen", "TopBarContext", undefined),
});

export const useTopBarContext = () => useContext(TopBarContext);

export const TopBarProvider: FC<{ children?: ReactNode }> = ({ children }) => {
	const [portal, setPortal] = useState<Portal>();
	const [sharePopoverOpen, setSharePopoverOpen] = useState(false);

	const setTopBarPortal = useCallback((portal: Portal) => {
		if (!portal.current) {
			return;
		}

		setPortal(portal);
	}, []);

	const value = useMemo(
		() => ({ portal, setTopBarPortal, sharePopoverOpen, setSharePopoverOpen }),
		[portal, setTopBarPortal, sharePopoverOpen]
	);
	return <TopBarContext.Provider value={value}>{children}</TopBarContext.Provider>;
};
